// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1JwXe","title":"ClientReferral_title__1kdbw","itemText":"ClientReferral_itemText__1NRDt"};